import { Button, Col, Modal, Row, Space, Form, Input, Select, FormInstance, message } from "antd";
import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
import { LineOutlined } from '@ant-design/icons';
import URL from "../../../server/URL";
import Server from "../../../server/Server";
import TextArea from "antd/es/input/TextArea";

interface IComparisonProductPriceEdit {
    viewMode: number,
    record: any,
    index: number,
    dataSource: any[],
    onOK: (record: any) => void
}

const ComparisonProductPriceEdit = forwardRef((props: IComparisonProductPriceEdit, ref: any) => {
    const { viewMode, index, record, dataSource } = props;
    const [visible, setVisible] = useState(false);

    const formRef = useRef<FormInstance>(null);

    useImperativeHandle(ref, () => ({
        setVisible: setVisible,
    }));

    useEffect(() => {
        if (visible) {
            switch (viewMode) {
                case 0:
                    setData(null);
                    break;
                case 1:
                    setData(props.record);
                    break;
                case 2:
                    setData(props.record);
                    break;
            }
        }
    }, [visible])

    const setData = (record: any) => {
        formRef.current?.resetFields();
        if (record) {
            formRef.current?.setFieldsValue({
                ...record,
                revenue: { value: record.revenueEnum, label: record.revenue },
            });
        }
        else {

        }
    }

    const onSave = () => {
        formRef.current?.validateFields().then((values => {
            // var filters = dataSource.filter((item: any) => item.revenue == values.revenue);
            // if (filters.length > 0) {
            //     message.warning('营业额[' + values.revenue + ']已存在，请勿重复添加');
            //     formRef.current?.scrollToField('revenue');
            //     return;
            // }
            if (values.singleLimit <= 0) {
                message.warning('请输入单笔限额.');
                formRef.current?.scrollToField('singleLimit');
                return;
            }
            if (values.insuranceAmount <= 0) {
                message.warning('请输入保费.');
                formRef.current?.scrollToField('insuranceAmount');
                return;
            }
            var isOK = props.onOK({
                ...values,
                index: index,
                revenueEnum: values.revenue.value,
                revenue: values.revenue.label,
                comparisonProductPriceID: values.comparisonProductPriceID,
            });
            setVisible(false);
        })).catch((info: any) => {
            console.log(info);
        });

    }

    const onClose = () => {
        setVisible(false);
    }

    const filterOption = (input: string, option?: { label: string; value: string }) =>
        (option?.label ?? '').toLowerCase().includes(input.toLowerCase());

    return <Modal width={500}
        centered visible={visible} title={'营业额[' + (record?.revenue ?? 'NULL') + ']'}
        maskClosable={false}
        onCancel={onClose}
        bodyStyle={{ padding: '0px' }}
        footer={<Space>
            <Button type="primary" onClick={onSave}>保存</Button>
            <Button danger onClick={onClose}>关闭</Button>
        </Space>}>
        <div style={{ maxHeight: '520px', overflow: 'auto', padding: '10px' }}>
            <Form ref={formRef}
                labelCol={{ flex: '105px' }}
                labelWrap
                scrollToFirstError={true}>
                <Row>
                    <Col span={24}>
                        <Form.Item label="营业额" style={{ marginBottom: '5px' }}
                            name="revenue"
                            initialValue={null}
                            rules={[{ required: true, message: '请选择营业额' }]}>
                            <Select style={{ width: '100%' }}
                                labelInValue
                                showSearch
                                optionFilterProp="children"
                                filterOption={filterOption}
                                options={[
                                    { value: '500', label: '500万及以下' },
                                    { value: '800', label: '800万及以下' },
                                    { value: '1000', label: '1000万及以下' },
                                    { value: '1500', label: '1500万及以下' },
                                    { value: '2000', label: '2000万及以下' },
                                    { value: '3000', label: '3000万及以下' },
                                    { value: '5000', label: '5000万及以下' },
                                    { value: '10000', label: '1亿及以下' },
                                    { value: '15000', label: '1.5亿及以下' },
                                    { value: '20000', label: '2亿及以下' },
                                    { value: '25000', label: '2.5亿及以下' },
                                    { value: '30000', label: '3亿及以下' },
                                ]} />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item label="单次限额" style={{ marginBottom: '5px' }}
                            name="singleLimit"
                            initialValue={0}>
                            <Input type='number' min={0} step={1} addonAfter={'万元'} />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item label="保费" style={{ marginBottom: '5px' }}
                            name="insuranceAmount"
                            initialValue={0}>
                            <Input type='number' min={0} step={0.01} addonAfter={'万元'} />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item label="备注" style={{ marginBottom: '25px' }}
                            name="remark"
                            initialValue={''}>
                            <TextArea showCount rows={3} maxLength={2000} />
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </div>
    </Modal>
});
export default ComparisonProductPriceEdit;